import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isPast from 'date-fns/is_past';

import FormattedDateTime from 'rebook/apps/base/components/FormattedDateTime';
import { parseApiDateTime } from 'rebook/apps/utils/datetime';

import styles from './style.scss';


const SubscriptionActiveTill = ({ date, extraClassName }) => {
  const subscriptionIsOutdated = isPast(parseApiDateTime(date));
  return (
    <div className={classNames(
      styles.subscriptionActiveTill,
      subscriptionIsOutdated ? styles.outdatedSubscription : styles.activeSubscription,
      extraClassName,
    )}>
      <div>
        {subscriptionIsOutdated ? 'Подписка закончилась' : 'Подписка активна до'}{' '}
        <FormattedDateTime timestamp={date} format="D MMMM YYYY" noWrap />
      </div>
    </div>
  );
};

SubscriptionActiveTill.propTypes = {
  date: PropTypes.string.isRequired,
  extraClassName: PropTypes.string,
};

export default SubscriptionActiveTill;
